import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-filter',
  templateUrl: './news-filter.component.html',
  styleUrls: ['./news-filter.component.css'],
})
export class NewsFilterComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
